// A per-group product (supplier_price_type 1) is priced for the whole group, e.g. a €700
// catamaran or a €190 stripper: both its Customer Price and Supplier Price are group totals, and
// its final rate is the group total too. A quote charges each guest the customer price divided by
// the quote's group size. See docs/reference/PER_GROUP_PRICES.md.
export function isPerGroup(option) {
    return !!option && parseInt(option.supplier_price_type) === 1
}

// What one guest pays for an option on a quote: its customer price, divided by the group size
// when it's per group (2 decimals, same as BuildService on save). No group size: the full price.
export function perPersonCustomerPrice(option, groupsize) {
    const price = parseFloat(option && option.customer_price) || 0
    const people = parseInt(groupsize)
    if (!isPerGroup(option) || !(people > 0)) return price
    return Math.round((price / people) * 100) / 100
}

// What we pay the supplier per person (per night for accommodation), or for the whole group on a
// per-group product, when no final rate has been entered on the Suppliers tab yet: the product's
// net Supplier Price, or the customer price when no net price is set (the quoted per-person rate,
// build.rate, or the group's customer price on a per-group product). Used to pre-fill final rates
// and in supplier emails.
export function defaultFinalRate(build) {
    const net = parseFloat(build && build.option ? build.option.supplier_price : 0)
    if (net > 0) return net
    if (build && isPerGroup(build.option)) return parseFloat(build.option.customer_price) || 0
    return (build && build.rate) || 0
}

// " per group" after a rate shown to staff or suppliers, else nothing.
export function rateSuffix(build) {
    return build && isPerGroup(build.option) ? ' per group' : ''
}

// One option's supplier cost per person for the quote's profit check: its net Supplier Price
// (divided by the group size when it's per group), or its per-person customer price when no net
// price is set.
export function perPersonSupplierCost(option, groupsize) {
    const net = parseFloat(option && option.supplier_price)
    if (!(net > 0)) return perPersonCustomerPrice(option, groupsize)
    if (!isPerGroup(option)) return net
    const people = parseInt(groupsize)
    return people > 0 ? net / people : net
}
